import { c as _c } from "react/compiler-runtime";
import { postHostedIdentifyValidationToken } from '@onefootprint/fetch-hosted';
import { useMutation } from '@tanstack/react-query';
const identifyValidateRequest = async ({
  authToken
}: {
  authToken: string;
}) => {
  const {
    data
  } = await postHostedIdentifyValidationToken({
    headers: {
      'X-Fp-Authorization': authToken
    }
  });
  return data;
};
const useIdentifyValidate = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: identifyValidateRequest
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useIdentifyValidate;